import { render, staticRenderFns } from "./DSets.vue?vue&type=template&id=1d1fa5b6&"
import script from "./DSets.vue?vue&type=script&lang=js&"
export * from "./DSets.vue?vue&type=script&lang=js&"
import style0 from "./DSets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports